export const newFormThemeOverrides: any = {
    MuiSelect: {
        styleOverrides: {
            outlined: {
                textAlign: 'right',
            },
        },
    },
}
